var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.teachingStaff.length)?[_c('UsersGroup',{staticClass:"box-shadow-white",attrs:{"users":_vm.teachingStaff}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }